import { enumValueGuard } from '@fmnts/core';

export enum Feature {
  Gamification = 'gamification',
  JobReferralLeaderboard = 'job_referral_leaderboard',
  LocationTracking = 'location_tracking',
  LocationModule = 'location_module',
  FundraiserQuizzes = 'fundraiser_quizzes',
  Marketplace = 'marketplace',
  MultiCampaignSetup = 'multi_campaign_setup',
  Launcher = 'launcher',
  Geolocation = 'capture_sign_up_coordinates',
  NewTerritoryManager = 'new_territory_management',
}
export type Features = `${Feature}`;

export const isFeature = enumValueGuard(Feature);
